import React from 'react';
import Expander from '@sats-group/fresh-fitness-ui-lib/react/expander';
import LinkButton from '@sats-group/fresh-fitness-ui-lib/react/link-button';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import NavigationCard from '@sats-group/fresh-fitness-ui-lib/react/navigation-card';

import Band from 'root/client/components/band/band';
import ContentContainer from 'root/client/components/content-container/content-container';
import Layout from 'root/client/components/layout/layout';
import PageHeader from 'root/client/components/page-header/page-header';
import RichText from 'root/client/components/rich-text/rich-text';

import type { CustomerServiceCategory as Props } from './customer-service-category.types';

const CustomerServiceCategory: React.FunctionComponent<Props> = ({
  header,
  layout,
  otherCategories,
  otherCategoriesTitle,
  questions,
  navigationCard,
}) => (
  <Layout {...layout} theme={Layout.themes.Primary}>
    <div className="customer-service-category">
      <PageHeader {...header} contentWidth={ContentContainer.widths.Medium} />
      <div className="customer-service-category__body">
        {navigationCard ? (
          <ContentContainer width={ContentContainer.widths.Medium}>
            <div className="customer-service-category__link-card">
              <NavigationCard
                {...navigationCard}
                variant={NavigationCard.variants.minExpanded}
              />
            </div>
          </ContentContainer>
        ) : null}
        <ContentContainer width={ContentContainer.widths.Medium}>
          <div className="customer-service-category__questions">
            <Expander itemRenderer={RichText} {...questions} />
          </div>
        </ContentContainer>
        <Band contentWidth={ContentContainer.widths.Medium} theme="secondary">
          <aside className="customer-service-category__other-categories">
            <Text
              elementName="h2"
              size={Text.sizes.header2}
              theme={Text.themes.emphasis}
              variant={Text.variants.hero}
            >
              {otherCategoriesTitle}
            </Text>
            <div className="customer-service-category__categories">
              {otherCategories.map(category => (
                <LinkButton
                  {...category}
                  key={category.href}
                  size={LinkButton.sizes.small}
                  theme={LinkButton.themes.secondary}
                />
              ))}
            </div>
          </aside>
        </Band>
      </div>
    </div>
  </Layout>
);

export default CustomerServiceCategory;
